<template>
<v-dialog
    v-model="dialog"
    max-width="600"
>
    <v-card>
    <v-card-title class="headline">{{label}}</v-card-title>

    <v-card-text>
        
        <v-select
            :label="label"
            :items="possible_values"
            v-model="value"
        />
        
    </v-card-text>

    <v-card-actions>
        <v-spacer></v-spacer>

        <v-btn
            color="gray darken-1"
            text
            @click="dialog = false"
        >
        Cancel
        </v-btn>

        <v-btn
            color="primary darken-1"
            text
            @click="onOk"
        >
        Ok
        </v-btn>
    </v-card-actions>
    </v-card>
</v-dialog>
</template>

<script>

const _ = require('lodash');

export default {

    props: {
        label: {
            type: String,
            default: function () { return ''; }
        },

        enum_name: {
            type: String,
            default: function() { return 'integration_name'; }
        },

        allow_any_enum_value: {
            type: Boolean,
            default: function() { return false; }
        },
    },

    data() {
        return {
            dialog: false,
            value: null,
        }
    },

    methods: {
        showDialog(value) 
        {
            this.value = value;
            this.dialog = true; 
        },
        
        onOk()
        {
            this.dialog = false;
            this.$emit('ok',this.value);
        },
    },

    computed: {
        possible_values() 
        {
            let ret = _.cloneDeep(this.$rc.enumChoices(this.enum_name));
            
            if ( !this.allow_any_enum_value )
            {
                ret.shift(); // remove the first value...
            }

            return ret;
        },
    },
}
</script>

<style lang="scss" scoped>

</style>